import { Component, Vue } from 'vue-property-decorator';
import { User } from '@/models/User';

@Component<Homepage>({
  components: {
    //
  },
})
export default class Homepage extends Vue {
  public $pageTitle = 'Home';

  public created(): void  {
    // As of 21/06/2022, we are bypassing all of the Style Quiz, and re-directing to /admin.
    this.$router.push({ name: 'admin.index' });
  }
}
